const domaineFormations = [
    { idDomaine: 1, nomDomaine: "Achats" },
    { idDomaine: 2, nomDomaine: "Assistant(e)" },
    { idDomaine: 3, nomDomaine: "Audit - Organisation - Conseil" },
    { idDomaine: 4, nomDomaine: "Banque" },
    { idDomaine: 5, nomDomaine: "Bureautique - PAO" },
    { idDomaine: 6, nomDomaine: "Coaching" },
    { idDomaine: 7, nomDomaine: "Commercial - Vente" },
    { idDomaine: 8, nomDomaine: "Communication" },
    { idDomaine: 9, nomDomaine: "Comptabilité - Fiscalité" },
    { idDomaine: 10, nomDomaine: "Conduite du changement" },
    { idDomaine: 11, nomDomaine: "Contrôle de gestion" },
    { idDomaine: 12, nomDomaine: "Création d'entreprise" },
    { idDomaine: 13, nomDomaine: "Digital" },
    { idDomaine: 14, nomDomaine: "Direction" },
    { idDomaine: 15, nomDomaine: "Droit" },
    { idDomaine: 16, nomDomaine: "Droit des affaires" },
    { idDomaine: 17, nomDomaine: "Développement personnel" },
    { idDomaine: 18, nomDomaine: "Efficacité professionnelle" },
    { idDomaine: 19, nomDomaine: "Finance - Trésorerie" },
    { idDomaine: 20, nomDomaine: "Formation" },
    { idDomaine: 21, nomDomaine: "Gestion du temps" },
    { idDomaine: 22, nomDomaine: "Immo & Services généraux" },
    { idDomaine: 23, nomDomaine: "Informatique - SI" },
    { idDomaine: 24, nomDomaine: "Innovation - Créativité" },
    { idDomaine: 25, nomDomaine: "International" },
    { idDomaine: 26, nomDomaine: "Logistique" },
    { idDomaine: 27, nomDomaine: "Management" },
    { idDomaine: 28, nomDomaine: "Marketing" },
    { idDomaine: 29, nomDomaine: "Organisation - Audit" },
    { idDomaine: 30, nomDomaine: "Paie/Admin du personnel" },
    { idDomaine: 31, nomDomaine: "Production" },
    { idDomaine: 32, nomDomaine: "Projet" },
    { idDomaine: 33, nomDomaine: "Qualité-Santé-Sécurité-Environnement" },
    { idDomaine: 34, nomDomaine: "Relation client" },
    { idDomaine: 35, nomDomaine: "Ressources Humaines" },
    { idDomaine: 36, nomDomaine: "Développement durable" },
    { idDomaine: 37, nomDomaine: "Secteur public" },
    { idDomaine: 38, nomDomaine: "Soft skills" },
    { idDomaine: 39, nomDomaine: "Travail à distance" },
    { idDomaine: 42, nomDomaine: "Langue" },
    { idDomaine: 43, nomDomaine: "Bureautique Microsoft Excel" },
    { idDomaine: 44, nomDomaine: "Bureautique Microsoft Power BI" },
    { idDomaine: 45, nomDomaine: "Bureautique Microsoft Powerpoint" },
    { idDomaine: 46, nomDomaine: "Bureautique Microsoft Word" },
    { idDomaine: 47, nomDomaine: "Bureautique Microsoft Access" },
    { idDomaine: 48, nomDomaine: "Art Oratoire" },
];

export default domaineFormations;
